import { render, staticRenderFns } from "./Subgroup.vue?vue&type=template&id=03f99938&"
import script from "./Subgroup.js?vue&type=script&lang=js&"
export * from "./Subgroup.js?vue&type=script&lang=js&"
import style0 from "./Subgroup.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports